import React from 'react';

const NumberFormatter = (props) => (
  <div className="number-formatter">{props.value}</div>
);

export default NumberFormatter;
